import { Node_Type, ButtonData_Type } from 'ricos-schema';
import { Node_Type as Node_Type$1 } from 'ricos-types';
import React, { useContext, useCallback } from 'react';
import { RicosContext, RicosViewerContext } from 'ricos-context';
import { normalizeHref, getRelValue } from 'wix-rich-content-common';

const LINK_BUTTON_TYPE = "wix-draft-plugin-link-button";
const ACTION_BUTTON_TYPE = "wix-draft-plugin-action-button";

const ALIGN_CENTER = "center";
const DEFAULT_CONFIG = {
  alignment: ALIGN_CENTER,
  size: "small",
  width: "fit-content"
};
({
  settings: {
    [ACTION_BUTTON_TYPE]: `${Node_Type.BUTTON}.actionButtonSettings`,
    [LINK_BUTTON_TYPE]: `${Node_Type.BUTTON}.linkButtonSettings`
  },
  alignment: {
    [ACTION_BUTTON_TYPE]: `${Node_Type.BUTTON}.actionButtonAlignment`,
    [LINK_BUTTON_TYPE]: `${Node_Type.BUTTON}.linkButtonAlignment`
  }
});

var styles = {"button_container":"pjn4l","button_text":"j-XVU","button_size_content":"y14Gy"};

const ROOT = "buttonViewer";

var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ButtonViewer = ({
  onClick,
  helpers,
  settings = {},
  buttonData,
  nodeId
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w;
  const { tabIndex } = useContext(RicosContext);
  const isActionButton = buttonData.type === ButtonData_Type.ACTION;
  const onClickHandler = useCallback(() => {
    var _a2;
    (_a2 = helpers == null ? void 0 : helpers.onViewerAction) == null ? void 0 : _a2.call(
      helpers,
      isActionButton ? ACTION_BUTTON_TYPE : LINK_BUTTON_TYPE,
      "Click",
      "",
      nodeId,
      {
        type: Node_Type.BUTTON,
        buttonData
      }
    );
    onClick == null ? void 0 : onClick();
  }, [helpers == null ? void 0 : helpers.onViewerAction]);
  const ButtonComponent = settings.customComponent ? settings.customComponent : isActionButton ? ActionButton : LinkButton;
  const style = {
    color: (_d = (_b = (_a = buttonData == null ? void 0 : buttonData.styles) == null ? void 0 : _a.colors) == null ? void 0 : _b.text) != null ? _d : (_c = settings.colors) == null ? void 0 : _c.color1,
    background: (_h = (_f = (_e = buttonData == null ? void 0 : buttonData.styles) == null ? void 0 : _e.colors) == null ? void 0 : _f.background) != null ? _h : (_g = settings.colors) == null ? void 0 : _g.color8,
    borderRadius: (_j = (_i = buttonData.styles) == null ? void 0 : _i.border) == null ? void 0 : _j.radius,
    width: `min(100%, ${(_l = (_k = buttonData.containerData) == null ? void 0 : _k.width) == null ? void 0 : _l.custom}px)`,
    border: `${((_n = (_m = buttonData.styles) == null ? void 0 : _m.border) == null ? void 0 : _n.width) || 0}px solid ${(_s = (_r = (_p = (_o = buttonData == null ? void 0 : buttonData.styles) == null ? void 0 : _o.colors) == null ? void 0 : _p.border) != null ? _r : (_q = settings.colors) == null ? void 0 : _q.color8) != null ? _s : ""}`
  };
  return /* @__PURE__ */ React.createElement(
    ButtonComponent,
    __spreadValues$1({
      className: styles.button_container,
      style,
      "data-hook": ROOT,
      onClick: onClickHandler,
      tabIndex,
      role: "button",
      buttonData,
      onKeyDown: (e) => {
        if (e.key === " " || e.key === "Enter") {
          e.preventDefault();
          onClickHandler();
        }
      }
    }, !isActionButton && {
      href: ((_t = buttonData.link) == null ? void 0 : _t.url) && normalizeHref(buttonData.link.url),
      target: ((_u = buttonData.link) == null ? void 0 : _u.target) && `_${buttonData.link.target.toLowerCase()}`,
      rel: ((_w = (_v = buttonData.link) == null ? void 0 : _v.rel) == null ? void 0 : _w.nofollow) ? getRelValue("nofollow") : void 0
    })
  );
};
const LinkButton = (props) => {
  const _a = props, { buttonData } = _a, rest = __objRest(_a, ["buttonData"]);
  return /* @__PURE__ */ React.createElement("a", __spreadValues$1({}, rest), /* @__PURE__ */ React.createElement("div", { className: styles.button_text }, buttonData.text));
};
const ActionButton = (props) => {
  const _a = props, { buttonData } = _a, rest = __objRest(_a, ["buttonData"]);
  return /* @__PURE__ */ React.createElement("div", __spreadValues$1({}, rest), /* @__PURE__ */ React.createElement("div", { className: styles.button_text }, buttonData.text));
};

const Button = ({ node, nodeIndex, NodeViewContainer }) => {
  var _a;
  const { helpers, config, onNodeClick } = useContext(RicosViewerContext);
  const settings = ((_a = node.buttonData) == null ? void 0 : _a.type) === "ACTION" ? config[ACTION_BUTTON_TYPE] : config[LINK_BUTTON_TYPE];
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { key: node.id, node, nodeIndex }, /* @__PURE__ */ React.createElement(
    ButtonViewer,
    {
      nodeId: node.id,
      helpers,
      settings,
      buttonData: node.buttonData,
      onClick: () => onNodeClick == null ? void 0 : onNodeClick({ node })
    }
  ));
};

const nodeViewRenderers = {
  [Node_Type$1.BUTTON]: Button
};

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginButton = (type, config) => {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULT_CONFIG), config),
    type,
    nodeViewRenderers
  };
};
const pluginLinkButton = (config) => {
  return pluginButton(LINK_BUTTON_TYPE, config);
};
const pluginActionButton = (config) => {
  return pluginButton(ACTION_BUTTON_TYPE, config);
};

export { ACTION_BUTTON_TYPE, LINK_BUTTON_TYPE, pluginActionButton, pluginLinkButton };
//# sourceMappingURL=viewer.js.map
